import React from 'react'
import PropTypes from 'prop-types'
import styles from './themes/default/styles.module.scss'

const Tab = ({children}) =>
  <div className={styles.tabChangeAnimation}>
    {children}
  </div>

Tab.propTypes = {children: PropTypes.any.isRequired}

export default Tab
